import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function FinalCallToAction() {
  return (
    <section className="container pb-16">
      <div className="relative overflow-hidden rounded-sm border border-border bg-gradient-deep p-10 text-primary-foreground sm:p-14">
        <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(hsl(0 0% 100% / 1) 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
        <div className="relative grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
          <div className="space-y-4 lg:col-span-8">
            <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-primary-foreground/70">
              § 03 · Begin
            </p>
            <h2 className="font-display text-3xl font-medium tracking-tight sm:text-4xl">
              A guided readiness snapshot. A documented next ninety days.
            </h2>
            <p className="max-w-2xl text-base leading-relaxed text-primary-foreground/80">
              The intake runs in your browser. Save to Server is optional and stores only a de-identified provider snapshot for owner review.
              At the end, the snapshot is yours to copy, share with your governance team, or
              hand to a qualified consultant.
            </p>
          </div>
          <div className="flex flex-col gap-3 lg:col-span-4 lg:items-end">
            <Button
              asChild
              size="lg"
              className="rounded-sm bg-primary-foreground px-6 text-[13px] font-medium tracking-wide text-primary hover:bg-primary-foreground/90"
            >
              <Link to="/intake">
                Begin readiness intake
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </Button>
            <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-primary-foreground/60">
              Consultant-guided · No login · No upload
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
